import { render, staticRenderFns } from "./SlideOutUnitDetails.vue?vue&type=template&id=5908de2b&"
import script from "./SlideOutUnitDetails.vue?vue&type=script&lang=js&"
export * from "./SlideOutUnitDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports